<template>
  <div>
    <h5>TERMOS DE USO DA APLICAÇÃO</h5>

    <p>A utilização dos aplicativos IGNIS implicam na aceitação do Termo de Uso (“Termo”) e pressupõem a leitura de todas as informações constantes neste documento.</p>

    <p>A Ignis Desenvolvimento de Sistemas Ltda. (IGNIS), inscrita no CNPJ sob o n. 31.948.332/0001-26, mantém o funcionamento desse aplicativo e os sistemas vinculados, sendo sua atividade regida pelas normas nacionais aplicáveis.</p>

    <p>O presente Termo incorpora-se como aditivo e acessório ao Contrato do sistema Ignis Gestão de Equipes firmado entre a {{customer}} e a IGNIS, aplicando-se as disposições e obrigações lá previstas à utilização dos aplicativos.</p>

    <p>Ao usar a aplicação, coletamos algumas Informações Pessoais (nome e telefone), Informações de Localização, Informações de Data e Hora de Acesso. Tais informações são necessárias para viabilizar nosso serviço e para o suporte técnico durante o período de testes e de funcionamento regular.</p>

    <p>Suas informações serão coletadas e utilizadas com o propósito único de viabilizar a utilização da plataforma e serão armazenadas em ambiente seguro e de acesso restrito, em atenção à preservação da intimidade, da vida privada, da honra e da imagem das partes direta ou indiretamente envolvidas.</p>

    <p>Ao utilizar a aplicação, mesmo que parcialmente ou a título de teste, o usuário consente com o Acesso, Coleta, Uso, Armazenamento, Tratamento e Técnicas de Proteção às informações dos usuários mencionadas anteriormente e necessárias para a integral execução das funcionalidades ofertadas.</p>

    <p>Em caso de discordância com os termos aqui apresentados, a utilização da aplicação deve ser imediatamente interrompida pelo usuário.</p>      
  </div>
</template>
<script>
  export default {
    name: 'SideMenu',
    data: function() {
      return {
        demo: process.env.FSM_DEMO,
        env: process.env.FSM_ENV,
        flavor: process.env.FSM_FLAVOR,
        customer: process.env.FSM_CUSTOMER
      }  
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/EulaText.vue